import React from 'react';

export const load = (Component) => (props) => {
  return (
    <React.Suspense fallback={null}>
      <Component {...props} />
    </React.Suspense>
  );
};
